import { AdminSectionComponent } from 'app/modules/core/containers/admin.component';
import { Routes } from '@angular/router';
import { AdminGuard } from 'app/modules/core/guards/admin';
import { LoggedInGuard } from 'app/modules/core/guards/logged-in';
import { ChangePasswordGuard } from 'app/modules/core/guards/change-password';
import { AboutUsComponent } from 'app/modules/irar/components/about-us';
import { AbbreviationComponent } from 'app/modules/irar/components/abbreviation';
import { HelpComponent } from 'app/modules/irar/components/help';
import { ContactComponent } from '../components/contact';
import { SiteMapComponent } from '../components/site-map';
import { LinksComponent } from '../components/links';
import { AdvancedSearchContainerComponent } from '../containers/advanced-search';
import { GoogleMapContainer } from '../containers/google-map'; 
import { MapSearchContainerComponent } from '../containers/map-search';
import { AdminHomeComponent } from 'app/modules/irar/components/admin';
import { AdminSectionContainerComponent } from 'app/modules/irar/containers/admin-section';
import { AdminSiteListContainerComponent } from '../containers/admin-site-list';
import { AdminDocumentsContainerComponent } from '../containers/admin-documents';
import { AdminManageSiteContainerComponent } from '../containers/admin-manage-site';
import { SearchResultsContainerComponent } from '../containers/search-results';
import { BarcLandingPageComponent } from '../containers/barc-landing';
import { GlenDaleComponent } from '../containers/glen-dale';

export const IrarRoutes: Routes = [
  { path: 'siteadmin',
    component: AdminSectionComponent,
    canActivate: [LoggedInGuard, ChangePasswordGuard, AdminGuard],
    data: {
      breadcrumb: 'Admin'
    }
  },
  {
    path: 'barc',
    component: BarcLandingPageComponent,
    canActivate: [],
    data: {
      breadcrumb: 'BARC',
      title: 'Beltsville Agricultural Research Center'
    }
  },
  {
    path: 'glenndale',
    component: GlenDaleComponent,
    canActivate: [],
    data: {
      breadcrumb: 'Glenn Dale',
      title: 'Glenn Dale Documents'
    }
  },
  {
    path: 'aboutus',
    component: AboutUsComponent,
    canActivate: [],
    data: {
      breadcrumb: 'About Us',
      title: 'About the Information Repository and Administrative Record'
    }
  },
  {
    path: 'abbreviations',
    component: AbbreviationComponent,
    canActivate: [],
    data: {
      breadcrumb: 'Abbreviations',
      title: 'Commonly Used Abbreviations'
    }
  },
  {
    path: 'help',
    component: HelpComponent,
    canActivate: [],
    data: {
      breadcrumb: 'Help',
      title: 'Help'
    }
  },
  {
    path: 'contactus',
    component: ContactComponent,
    canActivate: [],
    data: {
      breadcrumb: 'Contact Us',
      title: 'Contact Us'
    }
  },
  {
    path: 'sitemap',
    component: SiteMapComponent,
    canActivate: [],
    data: {
      breadcrumb: 'Site Map',
      title: 'Site Map'
    }
  },
  {
    path: 'links',
    component: LinksComponent,
    canActivate: [],
    data: {
      breadcrumb: 'Links of Interest',
      title: 'Links of Interest'
    }
  },
  {
    path: 'advancedsearch',
    component: AdvancedSearchContainerComponent,
    canActivate: [],
    data: {
      breadcrumb: 'Advanced Search',
      title: 'Advanced Search'
    }
  },
  {
    path: 'mapsearch',
    component: GoogleMapContainer,
    canActivate: [],
    data: {
      breadcrumb: 'Google Map Search',
      title: 'Google Map Search'
    }
  },
  {
    path: 'oldmapsearch',
    component: MapSearchContainerComponent,
    canActivate: [],
    data: {
      breadcrumb: 'Map Search',
      title: 'Map Search'
    }
  },
  {
    path: 'searchresults',
    component: SearchResultsContainerComponent,
    canActivate: [],
    data: {
      breadcrumb: 'Search Results',
      title: 'Document Search Results'
    }
  },
  {
    path: 'admin',
    component: AdminSectionContainerComponent,
    canActivate: [LoggedInGuard, ChangePasswordGuard],
    data: {
      breadcrumb: 'Admin'
    },
    children: [
      {
        path: '',
        component: AdminHomeComponent,
        data: {
          breadcrumb: '',
          title: 'Admin Home'
        }
      },
      {
        path: 'sites',
        component: AdminSiteListContainerComponent,
        data: {
          breadcrumb: 'Sites',
          title: 'Sites'
        }
      },
      {
        path: 'site/:id',
        component: AdminManageSiteContainerComponent,
        data: {
          breadcrumb: 'Edit Site',
          title: 'Edit a Site Description'
        }
      },
      {
        path: 'document',
        component: AdminDocumentsContainerComponent,
        data: {
          breadcrumb: 'Add Document',
          title: 'Add a Document'
        }
      },
      {
        path: 'document/:id',
        component: AdminDocumentsContainerComponent,
        data: {
          breadcrumb: 'Manage Document',
          title: 'Edit a Document'
        }
      },
      {
        path: 'documents',
        component: AdvancedSearchContainerComponent,
        data: {
          breadcrumb: 'Documents',
          title: 'Document Search'
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/routes/irar.ts